exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.map-loading[data-v-0ca41d2c]{top:10px;left:50%;transform:translate(-50%, 0);z-index:999;background-color:rgba(255,255,255,.8);padding:2px;border-radius:10px\n}\n.observation-map[data-v-0ca41d2c]{width:100%;height:50vh;min-height:400px\n}", ""]);

// exports
